import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';
import * as moment from 'moment';

@Component({
  selector: 'app-assign-task',
  templateUrl: './assign-task.component.html'
})
export class AssignTaskComponent {

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<AssignTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public inwards: Inward[]
  ) {
  }

  onOk(): void {
    this.dialogRef.close(true);
  }

  trackByFn(item: Inward): number {
    return item.id;
  }

  openReport(inward: Inward) {
    this.dialogRef.close();
    this.router.navigate(['/inwards',
      inward.id,
      'report',
      inward.reportId
    ]);
  }

  isOverdue(dueDate): boolean {
    return moment(dueDate, moment.ISO_8601).isBefore(moment(), 'days');
  }

}
